import { render, staticRenderFns } from "./caseBaseDetails.vue?vue&type=template&id=40ac7380&scoped=true"
import script from "./caseBaseDetails.vue?vue&type=script&lang=js"
export * from "./caseBaseDetails.vue?vue&type=script&lang=js"
import style0 from "./caseBaseDetails.vue?vue&type=style&index=0&id=40ac7380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac7380",
  null
  
)

export default component.exports